import { api } from "../api";

export const getAllCondominos = function (lockerId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominos/${lockerId}`;

    api
        .get(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getAllcondominos " + error);
        });
};

export const getCondominoById = function (condominoId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condomino/${condominoId}`;

    api
        .get(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getCondominoById " + error);
        });
};

export const saveCondomino = function (data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condomino`;

    api
        .post(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. saveCondomino " + error);
        });
};

export const updateCondominoLocker = function (lockerId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/export/condomino/rabbit`;

    api
        .post(URL, { "lockerId": lockerId })
        .then((response) => {
            console.log(response)
            callback(response);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. updateCondominoLocker " + error);
        });


};

export const deleteCondomino = function (condominoId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condomino/${condominoId}`;

    api
        .delete(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. deleteCondomino " + error);
        });
};

export const updateCondomino = function (condominoId, data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condomino/${condominoId}`;

    api
        .put(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. updateCondomino " + error);
        });
};

export const renotificaCondomino = function (data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/orders/renotifica`;

    api
        .post(URL, data)
        .then((response) => {
            console.log(response)
            callback(response);
        })
        .catch((error) => {
            console.log("Error:. renotificar condomino " + error);
        });
};
